<template>
  <section class="section container pt-3">
    <processes-datatable ref="processes_datatable" />
  </section>
</template>

<script>
import ProcessesDatatable from "./processes_datatable/Index.vue";

export default {
  name: "NgineComposerIndex",
  components: { ProcessesDatatable },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
